import React, {useState} from 'react'
import {Button, Col, Modal, Radio, Row} from "antd";
import {getEmployeeRolesById, assignRoleToEmployee} from "../../services/serviceEmployeeRole";

const radioStyle = {
    display: 'block'
};

const EmployeeRole = ({employeeId}) => {
    const [roleModal, setRoleModal] = useState(false);
    const [roleList, setRoleList] = useState([]);
    const [currentRole, setCurrentRole] = useState('');

    const handleRoleClick = async () => {
        await getEmployeeRolesById(employeeId)
            .then(({data}) => {
                data.forEach(item => {
                    if(item.hasRole !== '0'){
                        setCurrentRole(item.id);
                    }
                })
                setRoleList(data);
            });

        setRoleModal(!roleModal)
    };

    const handleChange = ({target}) => {
        assignRoleToEmployee({employeeId: employeeId, roleId: target.value})
            .then(() => {
                setCurrentRole(target.value)
            })
    };

    return (
        <React.Fragment>
            <Button
                type={'link'}
                onClick={() => handleRoleClick()}
            >
                Yetkilendir
            </Button>

            <Modal
                open={roleModal}
                onCancel={() => setRoleModal(!roleModal)}
                title={'Rol Listesi'}
                footer={[
                    <Button key={'CancelButton'} onClick={() => setRoleModal(!roleModal)}>Kapat</Button>
                ]}
            >
                <Row>
                    <Col span={24}>
                        <Radio.Group
                            onChange={handleChange}
                            defaultValue={currentRole}
                            value={currentRole}
                        >
                            {Object.keys(roleList).map((key) => {
                                let item = roleList[key]

                                return (
                                    <Radio
                                        style={radioStyle}
                                        value={item.id}
                                        key={item.id}
                                    >
                                        {item.name}
                                    </Radio>
                                )
                            })}
                        </Radio.Group>
                    </Col>
                </Row>
            </Modal>
        </React.Fragment>
    )
}
export default EmployeeRole
